import { tReduxAction } from "../types";
import {
  tChangeFilterApplicationType,
  tChangeFilterConnectionSourceAction,
  tChangeFilterConnectionStatusAction,
  tChangeFilterNextPageAction,
  tChangeFilterOrderStatusAction,
  tChangeFilterPayoutStatusAction,
  tChangeFilterPrevPageAction,
  tChangeFilterTermAction,
} from "./types";

export const changeFilterTerm = (payload: tChangeFilterTermAction["payload"]): tReduxAction => {
  return (dispatch) => {
    dispatch({ type: "CHANGE_FILTER_TERM", payload });
  };
};

export const changeFilterOrderStatus = (payload: tChangeFilterOrderStatusAction["payload"]): tReduxAction => {
  return (dispatch) => {
    dispatch({ type: "CHANGE_FILTER_ORDER_STATUS", payload });
  };
};

export const changeFilterPayoutStatus = (payload: tChangeFilterPayoutStatusAction["payload"]): tReduxAction => {
  return (dispatch) => {
    dispatch({ type: "CHANGE_FILTER_PAYOUT_STATUS", payload });
  };
};

export const changeFilterConnectionStatus = (payload: tChangeFilterConnectionStatusAction["payload"]): tReduxAction => {
  return (dispatch) => {
    dispatch({ type: "CHANGE_FILTER_CONNECTION_STATUS", payload });
  };
};

export const changeFilterConnectionSource = (payload: tChangeFilterConnectionSourceAction["payload"]): tReduxAction => {
  return (dispatch) => {
    dispatch({ type: "CHANGE_FILTER_CONNECTION_SOURCE", payload });
  };
};

export const changeFilterApplicationType = (payload: tChangeFilterApplicationType["payload"]): tReduxAction => {
  return (dispatch) => {
    dispatch({ type: "CHANGE_FILTER_APPLICATION_TYPE", payload });
  };
};

export const changeFilterPrevPage = (payload: tChangeFilterPrevPageAction["payload"]): tReduxAction => {
  return (dispatch) => {
    dispatch({ type: "CHANGE_FILTER_PREV_PAGE", payload });
  };
};

export const changeFilterNextPage = (payload: tChangeFilterNextPageAction["payload"]): tReduxAction => {
  return (dispatch) => {
    dispatch({ type: "CHANGE_FILTER_NEXT_PAGE", payload });
  };
};

export const resetFilters = (): tReduxAction => {
  return (dispatch) => {
    dispatch({ type: "RESET_FILTERS" });
  };
};
